import { render, staticRenderFns } from "./CampoTarifa.vue?vue&type=template&id=5d7db6e0"
import script from "./CampoTarifa.vue?vue&type=script&lang=js"
export * from "./CampoTarifa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports